import React from 'react';
import AppliedPaymentsReportAdmin from '../../Finance/ClientPayment/AppliedPaymentsReportAdmin';
import TabbedPage from '../../../Elements/TabbedPage';
import AppliedTpClientInvoiceReportAdmin from './AppliedTpClientInvoiceReportAdmin';

export default class TpAppliedReportParentAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  urlParams = new URLSearchParams(window.location.search);
  tab = this.urlParams.has('secondarytab') ? parseInt(this.urlParams.get('secondarytab')) : 0;

  componentDidMount() {}

  tabs = [
    {
      label: 'Third-Party Applied Payments Report',
      id: 'tppayments',
      icon: 'fa-solid fa-credit-card',
      component: <AppliedTpClientInvoiceReportAdmin />,
    },
    {
      label: 'Applied Payments Report',
      id: 'payments',
      icon: 'fa-solid fa-memo-circle-info',
      component: <AppliedPaymentsReportAdmin isTpRelated={true} />,
    },
  ];

  render() {
    return (
      <div className='contentwrapper'>
        {this.state.window}
        <div className='bg-white p-1'>
          <div className='TabbedPage'>
            <TabbedPage
              tabs={this.tabs}
              openOnTab={this.tab}
            />
          </div>
        </div>
      </div>
    );
  }
}
